import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import userSlice from './slices/userSlice';
import opportunitiesSlice from './slices/opportunitiesSlice';
import postsSlice from './slices/postsSlice';
import messagesSlice from './slices/messagesSlice';
import notificationsSlice from './slices/notificationsSlice';
import searchSlice from './slices/searchSlice';
import reviewsSlice from './slices/reviewsSlice'; // Add this import
import portfolioReducer from './slices/portfolioSlice'; // Add this
import collaborationReducer from './slices/collaborationSlice'; // Add this
import exploreSlice from './slices/exploreSlice';
import userRelationshipSlice from './slices/userRelationshipSlice';
import genericSlice from './slices/genericSlice';
import showcaseSlice from './slices/showcaseSlice';
import uploadSlice from './slices/uploadSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    user: userSlice,
    opportunities: opportunitiesSlice,
    posts: postsSlice,
    messages: messagesSlice,
    notifications: notificationsSlice,
    search: searchSlice,
    reviews: reviewsSlice, // Add this reducer
    portfolio: portfolioReducer, // Add this
    collaboration: collaborationReducer, // Add this
    explore: exploreSlice, // Add this
    userRelationship: userRelationshipSlice, // Add this
    generic: genericSlice,
    showcase: showcaseSlice,
    upload: uploadSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
